// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mew-banner[data-v-6a5f380e] {\n  background-size: cover;\n  background-position: center center;\n  border-top-left-radius: 10px;\n  border-top-right-radius: 10px;\n  min-height: 150px;\n  height: 100%;\n}\n.mew-banner .exit-container[data-v-6a5f380e] {\n  text-align: right;\n}", ""]);
// Exports
module.exports = exports;
